module.exports = __webpack_public_path__ + "static/media/alis14.9089967e.jpg";